import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuTableContainerComponent } from './au-table-container.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EmptyPlaceholderComponent } from '../empty-placeholder/empty-placeholder.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
@NgModule({
	imports: [
		CommonModule,
		MatProgressSpinnerModule,
		EmptyPlaceholderComponent,
		NgxTolgeeModule,
		AuTableContainerComponent,
	],
	exports: [AuTableContainerComponent],
})
export class AuTableContainerModule {}
